import React from "react";
import classnames from "classnames";
import { BREAKPOINTS, Element } from "src/components/base";
import LevelSide from "./side";
import LevelItem from "./item";

interface IProps {
    className?: string;
    children: React.ReactNode;
    tablet?: boolean;
    breakpoint?: BREAKPOINTS;
    narrow?: boolean;
}

function Level(props: IProps) {
    const { className, children, tablet, narrow, breakpoint, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(
                "level",
                "flex items-center justify-between",
                "[&_img]:inline-block [&_img]:align-top",
                "[&_code]:rounded-[2px]",
                className,
                {
                    [`is-${breakpoint}`]: breakpoint,
                    ["is-tablet"]: tablet,
                    ["is-narrow"]: narrow,
                } as any
            )}
        >
            {children}
        </Element>
    );
}

Level.Side = LevelSide;
Level.Item = LevelItem;

export default Level;
